"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: config/config-unauthenticated-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fconfig%2Fconfig-unauthenticated-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigUnauthenticatedServiceClient = exports.ConfigResponse = exports.ConfigRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const protobufPackage = 'com.step.config.proto';
function createBaseConfigRequest() {
    return {};
}
exports.ConfigRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ConfigRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseConfigRequest();
        return message;
    },
};
function createBaseConfigResponse() {
    return { translationsJson: '' };
}
exports.ConfigResponse = {
    fromJSON(object) {
        const message = {
            translationsJson: isSet(object.translationsJson)
                ? globalThis.String(object.translationsJson)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.translationsJson !== '') {
            obj.translationsJson = message.translationsJson;
        }
        return obj;
    },
    create(base) {
        return exports.ConfigResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConfigResponse();
        message.translationsJson = object.translationsJson ?? '';
        return message;
    },
};
class ConfigUnauthenticatedServiceClient {
    rpc;
    name = 'com.step.config.proto.ConfigUnauthenticatedService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/config';
    methods = [{
            name: 'GetConfig',
            requestType: exports.ConfigRequest,
            responseType: exports.ConfigResponse,
            authenticationOptions: undefined,
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    getConfig(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.ConfigUnauthenticatedServiceClient = ConfigUnauthenticatedServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=config-unauthenticated-service.js.map